import React from 'react';
import PanelHelpBadge from '../PanelHelpBadge';

export default function TemplateEditor({
  value,
  onChange,
  onSave,
  onReset,
  saving = false
}) {
  const v = value || {};
  const set = (key, next) => onChange?.({ ...v, [key]: next });

  const inputClassName = 'w-full rounded-xl border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900 px-3 py-2 text-sm';
  const selectClassName = 'rounded-xl border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900 px-2 py-2 text-sm';

  const FieldLabel = ({ title, description, interpretation }) => (
    <div className="mb-1 flex items-center gap-2">
      <p className="text-xs font-bold uppercase tracking-wide text-slate-500">{title}</p>
      <PanelHelpBadge title={title} description={description} interpretation={interpretation} />
    </div>
  );

  return (
    <div className="bg-white dark:bg-[#151f2b] rounded-2xl border border-slate-200 dark:border-slate-800 p-4 space-y-3">
      <div className="space-y-1">
        <h2 className="text-lg font-bold text-slate-900 dark:text-white">Şablon Düzenleyici</h2>
        <p className="text-xs text-slate-500">Bu panelde metni düzenlersin; karar kuralı değişmez. Akış: taslak - inceleme - onay - yayın.</p>
      </div>

      <div>
        <FieldLabel
          title="Şablon Anahtarı"
          description="Bu metnin sistemdeki teknik kimliğidir (templateKey)."
          interpretation="Aynı amaca hizmet eden metinler aynı templateKey ailesinde sürümlenir."
        />
        <input
          className={inputClassName}
          placeholder="Örnek: behavior.friction.primary.v1"
          value={v.templateKey || ''}
          onChange={(e) => set('templateKey', e.target.value)}
        />
      </div>

      <div>
        <FieldLabel
          title="Dil Anahtarı"
          description="I18n anahtarı; metnin çeviri ve dil bağlantısını temsil eder (i18nKey)."
          interpretation="Aynı i18nKey birden fazla dilde karşılık üretebilir."
        />
        <input
          className={inputClassName}
          placeholder="Örnek: behavior.friction.primary"
          value={v.i18nKey || ''}
          onChange={(e) => set('i18nKey', e.target.value)}
        />
      </div>

      <div>
        <FieldLabel
          title="Segment - Varyant - Ton"
          description="Metnin hangi davranış durumunda ve hangi ses tonunda kullanılacağını belirler."
          interpretation="Segment (Sıfırlama/Sürtünme/Dengeli/Güçlü), varyant (Birincil/İkincil/Destekleyici), ton (Nötr/Destekleyici)."
        />
      <div className="grid grid-cols-3 gap-2">
        <select className={selectClassName} value={v.segment || 'FRICTION'} onChange={(e) => set('segment', e.target.value)}>
          <option value="RESET">Sıfırlama</option>
          <option value="FRICTION">Sürtünme</option>
          <option value="STABLE">Dengeli</option>
          <option value="STRONG">Güçlü</option>
        </select>
        <select className={selectClassName} value={v.variant || 'primary'} onChange={(e) => set('variant', e.target.value)}>
          <option value="primary">Birincil</option>
          <option value="secondary">İkincil</option>
          <option value="reassurance">Destekleyici</option>
        </select>
        <select className={selectClassName} value={v.tone || 'neutral'} onChange={(e) => set('tone', e.target.value)}>
          <option value="neutral">Nötr</option>
          <option value="supportive">Destekleyici</option>
        </select>
      </div>
      </div>

      <div>
        <FieldLabel
          title="Mesaj Metni"
          description="Kullanıcıya gösterilecek nihai metin içeriği."
          interpretation="Kısa, yargısız ve açık olmalı; karar kuralını değiştirmez, sadece ifade eder."
        />
        <textarea
          className="w-full min-h-[120px] rounded-xl border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900 px-3 py-2 text-sm"
          placeholder="Mesaj metnini girin..."
          value={v.text || ''}
          onChange={(e) => set('text', e.target.value)}
        />
      </div>

      <div>
        <FieldLabel
          title="Değişiklik Özeti"
          description="Bu düzenlemenin neden yapıldığını kısa şekilde açıklar (changeSummary)."
          interpretation="İnceleme sırasında denetleyenin ilk baktığı alandır."
        />
        <input
          className={inputClassName}
          placeholder="Örnek: Sürtünme metni sade dil ile güncellendi"
          value={v.changeSummary || ''}
          onChange={(e) => set('changeSummary', e.target.value)}
        />
      </div>

      <div>
        <FieldLabel
          title="İnceleyene Not"
          description="Onaylayıcıya bağlam veya dikkat notu bırakırsın (notesForReviewer)."
          interpretation="Yayın riskini veya beklenen etkiyi belirtmek iyi pratiktir."
        />
        <input
          className={inputClassName}
          placeholder="Örnek: Bu metin sadece Sürtünme segmentinde test edilmeli"
          value={v.notesForReviewer || ''}
          onChange={(e) => set('notesForReviewer', e.target.value)}
        />
      </div>

      <div className="flex gap-2">
        <button disabled={saving} className="rounded-xl bg-primary px-4 py-2 text-sm font-bold text-white disabled:opacity-50" onClick={onSave}>Taslak Kaydet</button>
        <button className="rounded-xl bg-slate-100 dark:bg-slate-800 px-4 py-2 text-sm font-bold" onClick={onReset}>Temizle</button>
      </div>
    </div>
  );
}
